export default {
	install(Vue, options) {
		Vue.prototype.$track = {
			linkClick: trackData => {
				// data.store.dispatch('trackAction', {
				// 	category: `Detail Quote - Stock ${data.router.history.current.name}`,
				// 	name: trackData.name,	// ie. 'overview chart click'
				// 	label: trackData.label, // ie. '1 day' / customer-supplied data
				// 	value: data.store.state.symbol,	// maybe add French?
				// 	action: 'Link Click'
				// });
			},
			onClick: trackData => {
				// data.store.dispatch('trackAction', {
				// 	category: `Detail Quote - Stock ${data.router.history.current.name}`,
				// 	name: trackData.name,
				// 	label: trackData.label,
				// 	value: data.store.state.symbol,
				// 	action: 'On-Click'
				// });
			},
			pageView: trackData => {
				const data = {
					category: 'DIP',
					name: trackData.name,
					label: trackData.label,
					value: trackData.value,
					page: 'F2AppView'
				};

				try {
					window._waq.push(['_trackPageView', data]);
				} catch (e) {
					// do nothing
				}
			}
		};
	}
};



// WEBPACK FOOTER //
// ./src/shared/plugins/oda.js